<template>
  <component
    :is="to ? 'router-link' : href ? 'a' : 'button'"
    :to="to"
    :href="to ? undefined : href"
    class="btn"
    :class="[`btn--${variant}`, `btn--${size}`]"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: 'BaseButton',
  props: {
    variant: { type: String, default: 'primary' },
    size: { type: String, default: 'md' },
    to: { type: [String, Object], default: null },
    href: { type: String, default: null },
  },
}
</script>

<style scoped>
.btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  border: none;
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: var(--transition);
  white-space: nowrap;
  text-decoration: none;
  font-family: inherit;
}

.btn--md { padding: 12px 24px; font-size: 1rem; }
.btn--lg { padding: 16px 32px; font-size: 1.0625rem; }
.btn--sm { padding: 8px 16px; font-size: 0.875rem; }

.btn:focus-visible {
  outline: 3px solid var(--primary);
  outline-offset: 3px;
}

.btn--primary {
  background: var(--primary);
  color: var(--white);
}
.btn--primary:hover { background: var(--primary-dark); transform: translateY(-1px); }

.btn--outline {
  background: transparent;
  color: var(--primary);
  border: 2px solid var(--primary);
}
.btn--outline:hover { background: var(--primary-light); }

.btn--ghost {
  background: rgba(255,255,255,0.15);
  color: var(--white);
  border: 2px solid rgba(255,255,255,0.4);
}
.btn--ghost:hover { background: rgba(255,255,255,0.25); }
</style>
